module.exports = __webpack_public_path__ + "static/media/sky5.fa863610.jpg";